module.exports = __webpack_public_path__ + "img/infobuttonPressed.99e5b1ce.png";